import revive_payload_client_4sVQNw7RlN from "/data/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/data/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/data/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/data/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/data/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/data/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/data/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/data/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/data/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_UYiXMU8ZyN from "/data/app/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import directives_GDwrTGmylM from "/data/app/plugins/directives.js";
import emmit_pRCe3OOn7x from "/data/app/plugins/emmit.js";
import mdi_icons_3Bl9xeq499 from "/data/app/plugins/mdi-icons.js";
import touchevents_client_dmffkNhDEc from "/data/app/plugins/touchevents.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_UYiXMU8ZyN,
  directives_GDwrTGmylM,
  emmit_pRCe3OOn7x,
  mdi_icons_3Bl9xeq499,
  touchevents_client_dmffkNhDEc
]